import { connect } from "react-redux";
import { Nav, NavProps } from "Views/presentational/nav";
import { Store } from "Store/index";
import { navigate } from "Action_creators/navigate";

type StateProps = Pick<NavProps, "items" | "layout">;
type DispatchProps = Pick<NavProps, "onItemClick">;

function computeLayout(
  queries: Store["browser"]["matching_media_queries"]
): StateProps["layout"] {
  const isLargeScreen = queries.filter(query => query.id === "1440").length > 0;
  return isLargeScreen ? "FULL" : "COMPACT";
}

function computeNavItems(state: Store): StateProps["items"] {
  const filtered = state.pages.pages.filter(page => page.is_navigable === true);
  const ordered = filtered.sort((a, b) => a.menu_order - b.menu_order);

  return ordered.map(page => ({
    title: page.title,
    destination: page.slug,
    isActive: computeActiveNavItem(page, state)
  }));
}

function computeActiveNavItem(
  page: Store["pages"]["pages"][0],
  state: Store
): boolean {
  let isActive = false;
  const activeRoute = state.application.active_route;
  if (activeRoute.path === `/${page.slug}`) isActive = true;
  return isActive;
}

function mapStateToProps(state: Store): StateProps {
  return {
    items: computeNavItems(state),
    layout: computeLayout(state.browser.matching_media_queries)
  };
}

function mapDispatchToProps(): DispatchProps {
  return {
    onItemClick: destination =>
      navigate(new URL(destination, window.location.origin))
  };
}

const navHOC = connect(mapStateToProps, mapDispatchToProps())(Nav);
export { navHOC as NavHOC };
